import { render, staticRenderFns } from "./description-column.vue?vue&type=template&id=4e448868&scoped=true"
import script from "./description-column.vue?vue&type=script&lang=js"
export * from "./description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e448868",
  null
  
)

export default component.exports